import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-medicamento-detalhe-component',
    templateUrl: 'medicamento-detalhe-component.html',
    styleUrls: ['./medicamento-detalhe-component.scss']
})

export class MedicamentoDetalheComponent implements OnInit {
    @Input() medicamento: any;
    @Output() medicamentosVoltar = new EventEmitter();

    constructor(
    ) {
    }

    ngOnInit() {
    }

    async voltar() {
        this.medicamentosVoltar.emit();
    }
}
